import $ from "jquery";

const $documentElement = $(document.documentElement);

const pushDataLayerEvent = function (event) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push(event);
};

// START Page view event
$(function () {
  const language = $documentElement.prop("lang");
  const pathname = window.location.pathname.replace(`/${language}`, "");
  let pageType = "";
  switch (true) {
    case pathname === "":
      pageType = "homepage";
      break;
    case pathname === "/a2":
    case pathname === "/b1":
      pageType = "landing_page";
      break;
    case pathname === "/login":
      pageType = "login";
      break;
    case pathname === "/register":
      pageType = "register";
      break;
    case pathname === "/u":
      pageType = "user_profile";
      break;
    case pathname === "/c":
      pageType = "course_overview";
      break;
    case pathname === "/p/contact":
      pageType = "contact";
      break;
    case pathname.startsWith("/i/saved-cards"):
      pageType = "chapter_saved_cards";
      break;
    case pathname.startsWith("/i"):
      pageType = "item";
      break;
    case pathname.startsWith("/q"):
      pageType = "question";
      break;
    case pathname.startsWith("/exam-results"):
      pageType = "exam_results";
      break;
    case pathname.startsWith("/p"):
      pageType = "content_page";
      break;
    case pathname.startsWith("/purchase-results"):
      pageType = "purchase_results";
      break;
    case pathname.startsWith("/reset-password"):
      pageType = "reset_password";
      break;
  }

  const email = $documentElement.data("logged-in-as");
  const isUserLoggedIn = email ? true : false

  if (pageType) {
    pushDataLayerEvent({
      event: "pageview",
      user: {
        logged_in: isUserLoggedIn,
      },
      application: {
        id: "main",
        version: $documentElement.data("version"),
      },
      site: {
        language,
        mediaquery: window.matchMedia("(min-width: 1480px)").matches
          ? "large"
          : window.matchMedia("(min-width: 1080px)").matches
          ? "medium"
          : "small",
        environment: window.location.href.includes("https://www.")
          ? "production"
          : "development",
      },
      page: {
        type: pageType,
      },
    });

    const isSignUpTracked = window.sessionStorage.getItem(`is_sign_up_success_tracked`)
    if (pageType === "register") {
      window.sessionStorage.removeItem(`is_sign_up_success_tracked`);
    }
    if (isUserLoggedIn && isSignUpTracked) {
      window.sessionStorage.removeItem(`is_sign_up_success_tracked`);
      pushDataLayerEvent({
        event: "sign_up",
        email
      })
    }

    // START View Item List for 1 month and 12 months event
    $(".js-plan-select").on("click", function () {
      const duration = $(this).data("duration");
      const url = document.location.href;

      pushDataLayerEvent({
        event: "view_item_list",
        ecommerce: {
          items: [
            {
              item_name: url.substring(url.length - 2),
              item_id: 0,
              currency: "EUR",
              discount: 0,
              price: 0.0,
              item_variant: `${duration} month(s)`,
              item_brand: document.location.host,
            },
          ],
        },
      });
    });
    // End View Item List for 1 month and 12 months event
  }
});
// END Page view event

// START Login and Sign up success event
const urlSearchParams = new URLSearchParams(window.location.search);
const doUserEvent = function (event) {
  const email = $documentElement.data("logged-in-as");
  if (
    urlSearchParams.get(event) === "success" &&
    email &&
    !window.sessionStorage.getItem(`is_${event}_success_tracked`)
  ) {
    window.sessionStorage.setItem(`is_${event}_success_tracked`, true);
    pushDataLayerEvent({
      event,
      email,
    });
  }
};

// Register submit handler for sign up event
$('form[name="registration_form"]').on("submit", function () {
  window.sessionStorage.setItem(`is_sign_up_success_tracked`, true);
});

$(function () {
  doUserEvent("login");
});

$("#logout").on("click", function () {
  window.sessionStorage.removeItem("is_login_success_tracked");
});
// END Login and Sign up success event

// START Item List viewed event when user scrolls to the course select cards
const courseSelectCardsWrapper = document.getElementById("course-select-cards");
if (
  "IntersectionObserver" in window &&
  "IntersectionObserverEntry" in window &&
  "intersectionRatio" in window.IntersectionObserverEntry.prototype &&
  courseSelectCardsWrapper
) {
  let observer = new IntersectionObserver(([entry]) => {
    if (entry.isIntersecting) {
      const url = document.location.href;
      pushDataLayerEvent({
        event: "view_item_list",
        ecommerce: {
          items: [
            {
              item_name: url.substring(url.length - 2),
              item_id: 0,
              currency: "EUR",
              discount: 0,
              price: 0.0,
              item_variant: "6 month(s)",
              item_brand: document.location.host,
            },
          ],
        },
      });
    }
  });
  observer.observe(courseSelectCardsWrapper);
}
// END Item list viewed event

// START contact form submitted event
$("#contact-form").on("submit", function (e) {
  e.preventDefault();
  e.stopImmediatePropagation();
  e.stopPropagation();
  pushDataLayerEvent({
    event: "contact",
    form: {
      name: "contact",
      platform: "form",
    },
  });
  e.target.submit();
});
// END contact form submitted event

// START FAQ click event
$(".js-faq-btn").on("click", function () {
  const $this = $(this);
  const isOpenEvent = $this.hasClass("collapsed");
  const question = $this.data("question");
  pushDataLayerEvent({
    event: isOpenEvent ? "faq_open" : "faq_close",
    faq: question,
  });
});
// END FAQ click event

// START Text Message shown event
$(".js-app-flash").each(function () {
  const $this = $(this);
  const message = $this.data("message");
  if (message) {
    pushDataLayerEvent({
      event: "text_message",
      message_text: message,
    });
  }
});
// END Text Message shown event

// START Form validation event
$('form [type="submit"], #js-contact-form-submit').on("click", function () {
  setTimeout(() => {
    const invalidInput = $(this).closest("form").find(":invalid")[0];
    if (invalidInput) {
      pushDataLayerEvent({
        event: "validation_message",
        validation_field: invalidInput.name,
        validation_text: invalidInput.validationMessage,
      });
    }
  }, 0);
});
// END Form validation event

// START Update profile event
$('form[name="user_profile"]').on("submit", function () {
  pushDataLayerEvent({
    event: "update_profile",
  });
});
// END Update profile event

// START Select article event
if (window.location.pathname.includes("/p/news")) {
  $(".card-body.richtext-wrapper a").on("click", function () {
    const $this = $(this);
    pushDataLayerEvent({
      event: "select_article",
      article: $this.text(),
    });
  });
}
// END Select article event

// START Select schedule event
$(".js-go-to-schedule-btn").on("click", function () {
  const $this = $(this);
  const index = $this.data("index");
  pushDataLayerEvent({
    event: `schedule_${index}`,
  });
});
// END Select schedule event

// START View plans and pricing event
$('[href="#plans-and-pricing"]').on("click", function () {
  pushDataLayerEvent({
    event: "view_plans_pricing",
  });
});
// END View plans and pricing event

// START View online courses event
$('[href="#our-online-courses"]').on("click", function () {
  pushDataLayerEvent({
    event: "view_courses",
  });
});
// END View online courses event

// START Course Specific Events
const courseNavigationToggle = document.getElementsByClassName("js-course-navigation-toggle")[0];
let courseName = "";
if (courseNavigationToggle) {
  courseName = courseNavigationToggle.innerText.split("\n")[0];
}
const chapterNameElement = document.getElementsByClassName("js-video-chapter-name")[0];
let lessonName = "";
if (chapterNameElement) {
  lessonName = chapterNameElement.innerText;
}

const videoElement = document.getElementById("itemVideo");
if (videoElement) {
  const sourceElement = videoElement.querySelector('source');
  let videoName = "";
  if (sourceElement) {
    const src = sourceElement.getAttribute('src');
    videoName = src.split('/').pop(); // Specific Filename of the Video
  }

  window.dataLayer = window.dataLayer || [];
  // Detect when video playback starts
  videoElement.addEventListener('play', () => {
    window.dataLayer.push({
      event: "video_start",
      video: videoName,
      course: courseName,
      lesson: lessonName,
    });
  });

  // Define the timeupdate event handler as a named function
  function checkVideoProgressAboveNinetyPercent() {
    const currentTime = videoElement.currentTime;
    const duration = videoElement.duration;

    if (duration > 0 && currentTime / duration >= 0.9) {
      window.dataLayer.push({
        event: "video_finish",
        video: videoName,
        course: courseName,
        lesson: lessonName,
      });
      // Remove EventListener
      videoElement.removeEventListener('timeupdate', checkVideoProgressAboveNinetyPercent);
    }
  }
  videoElement.addEventListener('timeupdate', checkVideoProgressAboveNinetyPercent);
}

window.dataLayer = window.dataLayer || [];
const submitExamButton = document.getElementsByClassName("js-submit-exam")[0];
if (submitExamButton) {
  submitExamButton.addEventListener('click', () => {
    window.dataLayer.push({
      event: "submit_exam",
      course: courseName,
      exam: lessonName,
    });
  });
}
const submitAnswerButton = document.getElementsByClassName("js-submit-answer")[0];
if (submitAnswerButton) {
  submitAnswerButton.addEventListener('click', (e) => {
    window.dataLayer.push({
      event: "submit_answer",
      course: courseName,
      lesson: lessonName,
    });
  });
}
// END Course Specific Event
